/**
 * 解梦 API - 调用后端统一 AI 服务
 * 使用统一 axios 实例
 */
import api from '@/api/client'

/**
 * 分析梦境（并行心理分析 + 传统解梦）
 */
export async function analyzeDream(content, psychologyCallback, traditionalCallback) {
  if (!content) {
    throw new Error('请输入梦境内容')
  }

  try {
    // 并行请求心理分析和传统解梦
    // 注意：api 响应拦截器已拆包 response.data，所以返回的就是 data 对象
    const [psychologyRes, traditionalRes] = await Promise.all([
      api.post('/api/ai/dream/psychology', { content }),
      api.post('/api/ai/dream/traditional', { content })
    ])

    const psychologyResult = psychologyRes.result
    const traditionalResult = traditionalRes.result

    // 如果有回调，模拟流式输出效果
    if (psychologyCallback) {
      psychologyCallback(psychologyResult)
    }
    if (traditionalCallback) {
      traditionalCallback(traditionalResult)
    }

    return {
      psychology: psychologyResult,
      traditional: traditionalResult
    }
  } catch (error) {
    console.error('解梦失败:', error)
    throw error
  }
}

/**
 * 仅心理分析
 */
export async function analyzePsychology(content) {
  const response = await api.post('/api/ai/dream/psychology', { content })
  return response.result
}

/**
 * 仅传统解梦
 */
export async function analyzeTraditional(content) {
  const response = await api.post('/api/ai/dream/traditional', { content })
  return response.result
}

export default {
  analyzeDream,
  analyzePsychology,
  analyzeTraditional
}
